module.exports = __webpack_public_path__ + "img/icon-start-01.svg";